import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';

// Import base styles
import './index.css';
import './styles/GalleryViewer.css';
import './styles/GallerySearch.css';
import './styles/GalleryCard.css';
import './styles/GalleryDetail.css';
import './styles/EventCard.css';
import './styles/Navbar.css';
import './styles/Auth.css';
import './styles/SmartPulseAdmin.css';
import './styles/GalleryWallPlanner.css';

// Initialize PostHog (skip in development to avoid polluting analytics)
if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY && import.meta.env.VITE_ENVIRONMENT !== 'development') {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true,
    enable_recording_console_log: false,
    session_recording: {
      recordCrossOriginIframes: false,
    },
    // Drop all staging events to keep production analytics clean
    before_send: (event) => {
      if (import.meta.env.VITE_ENVIRONMENT === 'staging') {
        return null; // Drop event before transmission
      }
      return event;
    },
    loaded: (posthog) => {
      // Register environment as super property for production events
      if (import.meta.env.VITE_ENVIRONMENT === 'production') {
        posthog.register({ environment: 'production' });
      }
    },
  });
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React Error Boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>Please refresh the page or contact support.</p>
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <PostHogProvider client={posthog}>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </PostHogProvider>
);
